import { FC, Suspense, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { enableMapSet } from 'immer';

import { initializeFabric } from '@app/widgets/canvas/utils/initializeFabric';

import { store } from '@app/store';
import { TooltipProvider } from '@app/shared/ui/tooltip';
import { Toaster } from '@app/shared/ui/sonner';
import { router } from '@app/app/router';
import '@app/app/i18n'; // Инициализация i18n происходит при импорте

import ErrorBoundary from './app/providers/error-boundary';

import { LoadingScreen } from './components/template';

enableMapSet();

// Инициализируем Fabric.js при запуске приложения
initializeFabric();

export default function app() {
  const container = document.getElementById('root')!;
  const root = createRoot(container);
  root.render(<App />);
}

const App: FC = () => {
  const appRouter = useMemo(() => router(), []);

  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingScreen />}>
        <Provider store={store}>
          <TooltipProvider>
            <RouterProvider
              router={appRouter}
              future={{
                v7_startTransition: true,
              }}
            />
          </TooltipProvider>
          <Toaster />
        </Provider>
      </Suspense>
    </ErrorBoundary>
  );
};
